import React, { Dispatch, useEffect } from 'react';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../../../../../../../../store';
import { selectTransportadoraParceiraRequest } from '../../../../../../../../../store/ducks/transportadoras/actions';
import mask from '../../../../../../../../../utils/mask';

interface ITomador {
  selectCodTransportadora: React.Dispatch<React.SetStateAction<number>>;
  nomeTransportadora: string;
}

const ModalTransportadora: React.FC<ITomador> = ({
  selectCodTransportadora,
  nomeTransportadora,
}) => {
  const { Option } = Select;
  const dispatch = useDispatch<Dispatch<Action>>();

  const transportadoras = useSelector((state: ApplicationState) => state.Transportadoras.data);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo?.codCdd);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);

  useEffect(() => {
    dispatch(selectTransportadoraParceiraRequest(cddAtivo as number, inscricaoAtiva));
  }, [dispatch, cddAtivo, inscricaoAtiva]);

  const hadleSelect = (value: string, e: any) => {
    selectCodTransportadora(+e?.key);
  };

  return (
    <>
      <Select
        style={{ width: '100%', textAlign: 'center' }}
        onSelect={hadleSelect}
        placeholder={mask('transportadoraUf', nomeTransportadora)}
        filterOption={(inputValue, element) =>
          element?.props.children
            .toString()
            .toLowerCase()
            .replace(/\.|-|\//g, '')
            .includes(inputValue.replace(/\.|-|\//g, '').toLowerCase())
        }
        showSearch
      >
        {transportadoras?.map((item: any) => (
          <Option key={item.codParceiro} value={item.nomeParceiro}>
            {mask('transportadoraUf', item.nomeParceiro)}
            <br />
            {mask('cpfCnpj', item.cnpj)}
          </Option>
        ))}
      </Select>
    </>
  );
};

export default ModalTransportadora;
